import { FontColorEnum, FontSizeEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { I18nextTranslationKeys } from '@/i18n/i18next';

type ToolTipContentProps = {
  text: I18nextTranslationKeys;
  keyword?: string | null;
  modifiers?: Array<'Ctrl' | 'Shift' | 'Alt'>;
};

export function ToolTipContent({ text, keyword = null, modifiers = [] }: ToolTipContentProps) {
  const { t } = useTranslation();

  const keywordComponent = keyword ? (
    <Typography
      fontSize={FontSizeEnum.Xs}
      weight={FontWeightEnum.Bold}
      className="h-fit rounded-sm bg-white px-[5px] py-[1px] shadow-inner"
      color={FontColorEnum.Dark10}
    >
      {keyword}
    </Typography>
  ) : null;

  const renderShortcut = () => {
    if (!keyword) return null;

    if (modifiers.length === 0) return keywordComponent;

    return (
      <>
        {' ('}
        {modifiers.map((mod, index) => (
          <span key={mod}>
            {mod}
            {index < modifiers.length - 1 ? ' + ' : ' + '}
          </span>
        ))}
        {keywordComponent}
        {')'}
      </>
    );
  };

  return (
    <Typography fontSize={FontSizeEnum.Sm} className="flex items-end gap-[4px]">
      {t(text)}
      {renderShortcut()}
    </Typography>
  );
}
